import "./HomeScreen.style.css"
import {useNavigate} from "react-router-dom";
const HomeScreen = () => {
    const navigate = useNavigate();
    const navigateToCreateExercise = () => {
        navigate('/add-exercise')
    }
    
    return (
        <div className={"container"}>
            <span onClick={navigateToCreateExercise} className={"button"}>Dodaj ćwiczenie</span>
            <span className={"button quiz"}>Dodaj quiz</span>
        </div>
    )
}

export default HomeScreen;